import _ from 'lodash'
import * as _gFunc from './funcHelper'
import { useAccessControlStore } from '../store/modules/accessControlStore'
import { configs } from '../common/config'
import { checkUserInfo } from '../services/serviceAccessControl'

export function initAppCode(){
	let localAppCode = localStorage.getItem('app_code');
	if (_gFunc.isEmpty(localAppCode)) {
		
		//GET FROM ENV
		if (!_gFunc.isEmpty(configs.appCode)) {
			localAppCode = configs.appCode;
			localStorage.setItem('app_code', configs.appCode);
			
			//GET FROM SUB DOMAIN	
		} else {
			localAppCode = 'sas_v2';
			localStorage.setItem('app_code', 'sas_v2');
			// let resp = await checkAppCode(subHostname);
			// if (!_gFunc.isEmpty(resp) && resp?.success) {
			// 	localStorage.setItem('app_code', resp.data.application_code);
			// 	return resp.data.application_code;
			// }else{
			// 	console.error("Failed to set application code")
			// 	return null;
			// }
		} 
	} 
	return localAppCode;
}
export function appCode() {
	let app_code = localStorage.getItem('app_code');
	return !_gFunc.isEmpty(app_code) ? app_code : initAppCode();
}
export function isActiveSession() {
	let activeRemain = getActiveRemain();
	return activeRemain > 0;
}
export function isLoggedIn() {
	return !_gFunc.isEmpty(localStorage.getItem('token'));
}
export function isLoggedOut() {
	return !isLoggedIn();
}
export function getToken() {
	if (isActiveSession()) {
		return localStorage.getItem('token');
	}
	return '';
}
export function getActiveRemain() {
	let remaining = 0;
	if (isLoggedIn()) {
		if (!_gFunc.isEmpty(localStorage.getItem('exp'))) {
			let exp_date = localStorage.getItem('exp');
			let now_date = Math.round(new Date().getTime() / 1000);
			if (exp_date > 0) remaining = exp_date - now_date;
		}
	}
	return remaining;
}
export function getActiveUser(key, alternate = null) {
	let actUser = _gFunc.getLocalStorage('active_user');
	if (_gFunc.isEmpty(actUser)) return alternate;
	if (!Object.hasOwn(actUser, key)) return alternate;
	return actUser[key];
}
export function hasAuth(modules) {
	// return true;
	let access = _gFunc.getLocalStorage('access_codes');
	if (_gFunc.isEmpty(access)) return false;
	let intersect = _.intersection(access, modules);
	return (intersect.length > 0);
}
export function isAdmin() {
	if (!isActiveSession()) return false;
	let user = _gFunc.getLocalStorage('active_user');
	return (user?.user_type == 0);
}
export function isGuest() {
	if (!isActiveSession()) return true;
	let user = _gFunc.getLocalStorage('active_user');
	return (user?.user_type < 1);
}
export async function canAccess(to,from,next) {
	/* CHECK CONTAIN ACCESS TOKEN */
	if(!_gFunc.isEmpty(to.query.auth)){
		let data = JSON.parse(_gFunc.aesDecrypt(to.query.auth));
		if(!_gFunc.isEmpty(data.access_token) && !_gFunc.isEmpty(data.app_code)){
			useAccessControlStore().setActiveToken(data)
			let resp = await checkUserInfo();
			if (!_gFunc.isEmpty(resp) && resp?.success) {
				useAccessControlStore().setActiveUser(resp.data)
				next('/')
				return false;
			}
		}
	}

	/* CHECK HAS LOGIN */
	let stopInvLoop = ['login'];
	if (!isActiveSession() && !stopInvLoop.includes(to.name)) {
		// window.location.replace(configs.appUrl + '/login?r=' + to.path);
		next('/login?r=' + to.path)
	} 
	next()
}
export function hasAccess(to) {
	/* CHECK HAS ACCESS */
	if (_gFunc.isEmpty(to.meta.access_codes)) return true;

	if (hasAuth(to.meta.access_codes)) return true;

	window.location.href = configs.appUrl + '/error?c=403';
	
	return false;
}
export function logout(){
	localStorage.clear();
	window.location.href = '/login';
}